<template>
  <vue-good-table :columns="columns" :rows="years">
    <template slot="table-row" slot-scope="props">
      <span v-if="props.column.field == 'period'">
        <span>{{ formatDate(props.row.startAt) }} ถึง {{ formatDate(props.row.endAt) }}</span>
      </span>
      <span v-if="props.column.field == 'action'">
        <b-button variant="primary" block size="sm" :to="{ name: 'settings.ac-years.show', params: { id: props.row.id } }">
          ดูข้อมูล
        </b-button>
      </span>
      <span v-else>{{ props.row[props.column.field] }}</span>
    </template>
  </vue-good-table>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
import moment from 'moment'

export default {
  components: {
    VueGoodTable
  },
  props: {
    years: { type: Array, required: true }
  },
  data () {
    return {
      columns: [
        {
          label: 'ปีการศึกษา',
          field: 'year'
        },
        {
          label: 'ระยะเวลา',
          field: 'period'
        },
        {
          label: 'การกระทำ',
          field: 'action',
          width: '95px'
        }
      ]
    }
  },
  methods: {
    formatDate (date) {
      return moment(date).format('DD-MM-YYYY')
    }
  }
}
</script>
